import { useEffect } from "react";
import { Platform } from "react-native";

export function formatPageTitle(
  primary: string,
  courseTitle?: string | null,
): string {
  const trimmedPrimary = primary.trim();
  const trimmedCourse = courseTitle?.trim();
  if (trimmedCourse) {
    return `${trimmedPrimary} (${trimmedCourse})`;
  }
  return trimmedPrimary;
}

export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    if (Platform.OS !== "web" || typeof document === "undefined") return;
    const trimmed = title?.trim();
    if (!trimmed) return;
    document.title = trimmed;
  }, [title]);
}
